module.exports = __webpack_public_path__ + "img/setting.7166b53d.png";